module.exports = __webpack_public_path__ + "img/step_process.9255a026.png";